import React, { Component } from "react";
import { GooglePlayLogo, AppStoreLogo } from "phosphor-react";
class How extends Component {
  render() {
    return (
      <>
        <section className="lg:relative  ">
          <h2 className="font-black  text-center text-6xl mt-24 ">
            How does it work?
          </h2>
          <div className="mx-auto max-w-screen-xl grid grid-cols-3  gap-12 mt-24 mb-32    ">
            <div className="shadow-lg p-12 rounded-xl border">
              <h3 className="font-light text-3xl  rounded-full  text-black   ">
                Step 1
              </h3>
              <ul className="text-xl  mt-12 ">
                <li className="font-bold">
                  Start by telling us a little about your business.
                </li>
              </ul>
              <p className="text-lg  mt-12  bg-yellow-100 rounded-xl p-6 flex leading-snug ">
                <img src="images/bee-sm.svg" alt="" className="pr-6" />
                We will start you off with a set of starter modules.
              </p>
            </div>
            <div className="shadow-lg p-12 rounded-xl border">
              <h3 className="font-light text-3xl  rounded-full  text-black  ">
                Step 2
              </h3>
              <ul className=" font-normal mt-12 leading-relaxed ">
                <li className=" pb-8 text-xl font-bold">
                  Add, remove or edit service modules as you see fit.
                </li>
                <li className=" pb-8 text-lg">
                  Save, share and gather feedback with your team members.
                </li>
                <li className="text-lg">
                  Hit the 'looks good' button when you are ready. <br />{" "}
                  <b className="font-bold">Thats it!</b>
                </li>
              </ul>

              <p className="text-lg  mt-12  bg-yellow-100 rounded-xl p-6 flex leading-snug">
                <img src="images/bee-sm.svg" alt="" className="pr-6" />
                Seek help from a SB expert at any point in time.
              </p>
            </div>
            <div className="shadow-lg p-12 rounded-xl border">
              <h3 className="font-light text-3xl  rounded-full  text-black  ">
                Step 3
              </h3>

              <p className="text-lg  mt-12  bg-yellow-100 rounded-xl p-6 ">
                <img src="images/bee-sm.svg" alt="" className="pb-6" />A
                dedicated SB team will work with you on:{" "}
                <ul className=" font-normal mt-2 leading-relaxed px-4 text-sm">
                  <li className="list-disc">branding and content</li>
                  <li className="list-disc">
                    domains, contracts and hosting logistics
                  </li>
                  <li className="list-disc">team onboarding and training</li>
                </ul>
              </p>
              <p className="text-xl font-bold mt-12 leading-snug ">
                Download your app from iPhone App Store and Google Play store.
              </p>
              <div className="flex mt-6 gap-6">
                <GooglePlayLogo size={32} weight="fill" />
                <AppStoreLogo size={32} weight="fill" />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default How;
